import type { DataTransferImportSource } from "./types";

/**
 * data import sources lists
 */
export const IMPORT_SOURCES: Record<string, DataTransferImportSource> =
  Object.freeze({
    simplePractice: {
      id: "simplePractice",
      name: "Simple Practice",
      // TODO: add link here
      url: "/",
    },
    therapyNotes: {
      id: "therapyNotes",
      name: "Therapy Notes",
      disabled: true,
      // TODO: add link here
      url: "/",
    },
  });

/**
 * accept upload file extension allowlist
 */
export const UPLOAD_FILE_ACCEPT = "application/zip";

/**
 * task status for data transfer upload task
 */
export const DATA_TRANSFER_UPLOAD_TASK_STATES = Object.freeze({
  cancelled: "cancelled",
  uploading: "uploading",
  complete: "complete",
  failed: "failed",
} as const);
